// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root .button_link {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 35px;\n    cursor: pointer;\n    border-radius: 4px;\n    border: 1px solid;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    padding: 10px;\n    font-size: 14px;\n    text-align: center;\n    background: #f1f5fa;\n    color: #2196f3;\n    border-color: transparent;\n  }\n", ""]);
// Exports
module.exports = exports;
